import create from 'zustand/vanilla';
import createHook from 'zustand';
import {
  getDateKey,
  getTodayDate
} from '@cont/Planner/planner-utils/date-time-helper';
import { emptyObject } from '@constants/empty';

export const featuresAndBrowseCardStore = create((set) => ({
  plannerExtraInfo: emptyObject,
  setFeatureCards: (
    goalUID,
    featureCards,
    dateKey = getDateKey(getTodayDate().date)
  ) => {
    set((state) => ({
      ...state,
      plannerExtraInfo: {
        ...state.plannerExtraInfo,
        [goalUID]: {
          ...state.plannerExtraInfo?.[goalUID],
          [dateKey]: {
            ...state.plannerExtraInfo[goalUID]?.[dateKey],
            featureCards
          }
        }
      }
    }));
  },
  setShowBrowse: (
    goalUID,
    showBrowse,
    dateKey = getDateKey(getTodayDate().date)
  ) => {
    set((state) => ({
      ...state,
      plannerExtraInfo: {
        ...state.plannerExtraInfo,
        [goalUID]: {
          ...state.plannerExtraInfo?.[goalUID],
          [dateKey]: {
            ...state.plannerExtraInfo[goalUID]?.[dateKey],
            showBrowse
          }
        }
      }
    }));
  }
}));

const useFeaturesAndBrowseCardStore = createHook(featuresAndBrowseCardStore);

export default useFeaturesAndBrowseCardStore;
